import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Chip from 'material-ui/Chip';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import { red300 } from 'material-ui/styles/colors';

import { updateImageSnInput } from '../../../actions/SearchParameter.Actions';

class ImageSNField extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateImageSNInput = this.handleUpdateImageSNInput.bind(this);
    this.handleDeleteAll = this.handleDeleteAll.bind(this);
    this.handleDeleteRequest = this.handleDeleteRequest.bind(this);
  }

  handleUpdateImageSNInput({ charCode }) {
    if (charCode === 13) /* The enter key */ {
      const { imageSN: { input }, dispatch } = this.props;
      const value = Number(this.textField.getValue());
      if (Number.isNaN(value)) {
        console.warn('Cannot input non-numeric values');
      }

      if (!input.includes(value)) {
        const result = [...input, value];
        dispatch(updateImageSnInput(result));
      } else {
        console.warn('Value has already been included.');
      }
      this.textField.getInputNode().value = '';
    }
  }

  handleDeleteAll() {
    const { dispatch } = this.props;
    dispatch(updateImageSnInput([]));
  }

  handleDeleteRequest(key) {
    const { dispatch, imageSN: { input } } = this.props;
    const result = [...input];
    result.splice(result.indexOf(key), 1);
    dispatch(updateImageSnInput(result));
  }

  render() {
    const {
      imageSN: { input },
      textFieldStyle,
      chipsWrapperStyle,
      chipConfig,
      chipStyle,
      buttonGroupStyle,
      flatButtonStyle
    } = this.props;

    return (
      <div className="ImageSNField">
        <TextField
          ref={(c) => { this.textField = c; }}
          onKeyPress={this.handleUpdateImageSNInput}
          floatingLabelText="Search by Image SNs"
          {...textFieldStyle}
        />

        <div className="chips-wrapper" style={chipsWrapperStyle}>
          {
            input.map(chip => (
              <Chip
                key={chip}
                onRequestDelete={() => this.handleDeleteRequest(chip)}
                style={chipStyle}
                {...chipConfig}
              >
                {chip}
              </Chip>
            ))
          }
        </div>

        <div className="button-group" style={buttonGroupStyle}>
          <FlatButton
            backgroundColor="#666"
            style={{ ...flatButtonStyle, color: input.length ? flatButtonStyle.color : '#aaa' }}
            hoverColor={red300}
            disabled={input.length === 0}
            onClick={this.handleDeleteAll}
          >
            Delete All
          </FlatButton>
        </div>
      </div>
    );
  }
}

ImageSNField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  imageSN: PropTypes.shape({
    input: PropTypes.arrayOf(PropTypes.number).isRequired
  }).isRequired,
  textFieldStyle: PropTypes.object,
  chipsWrapperStyle: PropTypes.object,
  chipConfig: PropTypes.object,
  chipStyle: PropTypes.object,
  buttonGroupStyle: PropTypes.object,
  flatButtonStyle: PropTypes.object
};

ImageSNField.defaultProps = {
  textFieldStyle: {
    underlineStyle: { borderColor: '#888' },
    underlineFocusStyle: { borderColor: '#ddd' },
    floatingLabelStyle: { color: 'white' },
    inputStyle: { color: 'white' },
    fullWidth: true
  },
  chipsWrapperStyle: {
    padding: '5pt 0',
    marginBottom: '10pt',
    whiteSpace: 'normal'
  },
  chipConfig: {
    labelStyle: {
      verticalAlign: 'top',
      fontWeight: 400
    }
  },
  chipStyle: {
    display: 'inline-block',
    marginRight: '5pt',
    marginBottom: '5pt',
    fontFamily: "'Quicksand', sans-serif",
    backgroundColor: '#eee'
  },
  buttonGroupStyle: {
    textAlign: 'right',
    marginBottom: '10pt'
  },
  flatButtonStyle: {
    color: 'white',
    marginLeft: '5pt',
    fontSize: '10pt'
  }
};

function mapStateToProps({ SearchParameter: { imageSN } }) {
  return { imageSN };
}

export default connect(mapStateToProps)(ImageSNField);



// WEBPACK FOOTER //
// ./src/containers/Aside/ImageSearchGroup/ImageSNField.jsx